import { BtixConstant } from "../constant";
const loadingSelector = "#loading";
const submitSelector = ".need-loading";
// ローディング開閉
export const initLoadinglControl = () => {
    // 毎回書かなくてもいいようにローダー画面を差し込む
    const loaderHtml = `
        <!-- loading -->
        <div id="loading" class="is-hide">
            <div class="spinner">
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="circle"></div>
                <div class="shadow"></div>
                <div class="shadow"></div>
                <div class="shadow"></div>
                <div class="loadingMessage">
                    処理中です
                </div>
            </div>
        </div>
        <!-- loading -->
    `;
    document.getElementsByTagName("body")[0].insertAdjacentHTML("afterbegin", loaderHtml);
    // プログレス表示が必要なものはsubmitボタンにneed-loadingクラスを付与しておく
    const formSubmitButton = document.querySelector(submitSelector);
    if (formSubmitButton === null)
        return;
    formSubmitButton.addEventListener(BtixConstant.touchOrClickEvent(), (event) => {
        showLoading();
        const targetButton = event.target;
        // そのままだとsubmitしてくれなくなるので、フォームのサブミットを実行する
        targetButton.form?.submit();
    });
};
export const showLoading = () => {
    const loadingElement = document.querySelector(loadingSelector);
    if (loadingElement === null)
        return;
    loadingElement.classList.remove("is-hide");
};
export const hideLoading = () => {
    const loadingElement = document.querySelector(loadingSelector);
    if (loadingElement === null)
        return;
    loadingElement.classList.add("is-hide");
};
